import React, { FC } from "react";
import darkFolderIcon from "../../../../assets/svg/darkFolderIcon.svg";
import "./index.scss";

interface NoticeWorkflowCardProps {
  title: string;
  description: string;
}

export const NoticeWorkflowCards: FC<NoticeWorkflowCardProps> = ({
  title,
  description,
}) => {
  return (
      <div className="notice-workflow-card">
        {/* Icon */}
        <img
          src={darkFolderIcon}
          alt="Folder Icon"
          className="notice-workflow-card__icon"
        />

        {/* Text content */}
        <div>
          <h3 className="notice-workflow-card__title">{title}</h3>
          <div className="notice-workflow-card__description">{description}</div>
        </div>
      </div>
  );
};
